import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { PhoneCall ,CheckCircle2, Clock, FileText, Info,} from 'lucide-react';
import { DialogFooter ,Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,} from './ui/dialog';

const ServiceModal = ({ isOpen, onClose, service }) => {
  if (!service) return null;

  const IconComponent = service.icon;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden bg-white rounded-2xl">
        {/* Header Banner */}
        <div className={`w-full h-24 bg-gradient-to-r ${service.color} relative`}>
          <div className="absolute -bottom-8 left-6">
            <div className="w-16 h-16 rounded-2xl bg-white shadow-lg flex items-center justify-center p-1">
              <div className={`w-full h-full rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center`}>
                <IconComponent className="w-8 h-8 text-white" />
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 pt-12 pb-6 max-h-[80vh] overflow-y-auto">
          <DialogHeader className="mb-6 text-left">
            <div className="flex items-center justify-between mb-2">
              <DialogTitle className="text-2xl font-bold text-slate-900">
                {service.name}
              </DialogTitle>
              <Badge variant="outline" className="bg-slate-100 text-slate-700 border-slate-200">
                {service.category}
              </Badge>
            </div>
            <DialogDescription className="text-base text-slate-600 mt-2">
              {service.description}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-6">
            {/* What's Included */}
            <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
              <h4 className="font-semibold text-slate-800 flex items-center mb-3">
                <CheckCircle2 className="w-5 h-5 mr-2 text-green-500" />
                What's Included
              </h4>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {service.included.map((item, index) => (
                  <li key={index} className="flex items-start text-sm text-slate-700">
                    <span className="mr-2 mt-1 text-green-500">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Required Documents */}
            <div>
              <h4 className="font-semibold text-slate-800 flex items-center mb-3">
                <FileText className="w-5 h-5 mr-2 text-blue-500" />
                Required Documents
              </h4>
              <ul className="space-y-2">
                {service.documents.map((doc, index) => (
                  <li key={index} className="flex items-center text-sm text-slate-600 bg-white border border-slate-200 rounded-lg p-2.5 shadow-sm">
                    <div className="w-2 h-2 rounded-full bg-blue-400 mr-3"></div>
                    {doc}
                  </li>
                ))}
              </ul>
            </div>

            {/* How to Apply & Processing Time */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-blue-50/50 rounded-xl p-4 border border-blue-100">
                <h4 className="font-semibold text-slate-800 flex items-center mb-2 text-sm">
                  <Info className="w-4 h-4 mr-2 text-blue-600" />
                  How to Apply
                </h4>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {service.howToApply}
                </p>
              </div>
              <div className="bg-amber-50/50 rounded-xl p-4 border border-amber-100">
                <h4 className="font-semibold text-slate-800 flex items-center mb-2 text-sm">
                  <Clock className="w-4 h-4 mr-2 text-amber-600" />
                  Processing Time
                </h4>
                <p className="text-sm text-slate-600 font-medium">
                  {service.processingTime}
                </p>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter className="px-6 py-4 bg-slate-50 border-t border-slate-100 sm:justify-between flex-col sm:flex-row gap-3">
          <p className="text-xs text-slate-500 flex items-center justify-center sm:justify-start">
            Need help? Call us at <strong className="ml-1 text-slate-700">8531021480</strong>
          </p>
          <div className="flex gap-2 w-full sm:w-auto">
            <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
              Close
            </Button>
            <a href="tel:8531021480" className="w-full sm:w-auto">
              <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                <PhoneCall className="w-4 h-4 mr-2" />
                Contact Now
              </Button>
            </a>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceModal;